import { eventRegistry } from '../events/registry';

// TODO: do we need this router or can each individual track file listen for its own events?
export default class AnalyticsEventRouter {
  constructor() {
    window.site = window.site || {};
    window.site.track = window.site.track || {};

    window.addEventListener('cart.offerSuccess', (event: CustomEvent) => {
      this.onOffer('offerSuccessful', event);
    });
    window.addEventListener('cart.offerFail', (event: CustomEvent) => {
      this.onOffer('offerFailed', event);
    });
    window.addEventListener('cart.offerRemove', (event: CustomEvent) => {
      this.onOffer('offerRemove', event);
    });
    window.addEventListener('cart.sampleAdded', (event: CustomEvent) => {
      this.onSampleAdded(event);
    });
    window.addEventListener('cart.sampleRemoved', (event: CustomEvent) => {
      this.onSampleRemoved(event);
    });
    window.addEventListener('cart.removeFromCart', (event: CustomEvent) => {
      this.onRemoveFromCart(event);
    });
    window.addEventListener('cart.addToCart', (event: CustomEvent) => {
      this.onAddToCart(event);
    });
    window.addEventListener('iam.registration', (event: CustomEvent) => {
      this.onRegistration(event);
    });
    window.addEventListener('iam.registrationFailed', (event: CustomEvent) => {
      this.onRegistrationFailed(event);
    });
    window.addEventListener('iam.signIn', (event: CustomEvent) => {
      this.onSignIn(event);
    });
    window.addEventListener('iam.signInFailed', (event: CustomEvent) => {
      this.onSignInFailed(event);
    });
    window.addEventListener('nav.globalNavClick', (event: CustomEvent) => {
      this.onGlobalNavClick(event);
    });
    window.addEventListener('nav.subNavClick', (event: CustomEvent) => {
      this.onSubNavClick(event);
    });
    window.addEventListener('analytics.overlayProductClick', (event: CustomEvent) => {
      this.onOverlayProductClick(event);
    });
    window.addEventListener('product.productClick', (event: CustomEvent) => {
      this.onProductClick(event);
    });
    window.addEventListener('product.quickshop.clicked', (event: CustomEvent) => {
      this.onQuickshopClick(event);
    });
    window.addEventListener('searchOverlayDisplayedEvent', () => {
      this.onSearchOverlayDisplayed();
    });
    window.addEventListener('cart.drawer.clicked', (event: CustomEvent) => {
      this.onCartDrawer(event);
    });
    window.addEventListener('phx:trackEvent', (event: CustomEvent) => {
      // add additional cases for new event
      switch (event?.detail?.event_name) {
        case 'sortEvent':
          this.onSortClick(event);
          break;
        case 'searchPageLoadedEvent':
          this.onSearchPageLoadedEvent(event);
          break;
        case 'searchPredictedEvent':
          this.onSearchPredicted(event);
          break;
        default:
          break;
      }
    });
    window.addEventListener('pdp.accordion', (event: CustomEvent) => {
      this.onPdpAccordion(event);
    });
  }

  // TODO: move this data translation to the track file on next refactor
  onSearchPageLoadedEvent(event: CustomEvent) {
    const eventName = 'searchPageLoaded';
    const searchPageLoaded = event?.detail?.payload?.value || '';
    if (searchPageLoaded) {
      eventRegistry[eventName]?.(eventName, searchPageLoaded);
    }
  }

  onSearchPredicted(event: CustomEvent) {
    const eventName = 'searchPredicted';
    const searchPredicted = event?.detail?.payload?.value || '';
    if (searchPredicted) {
      eventRegistry[eventName]?.(eventName, searchPredicted);
    }
  }

  onSearchOverlayDisplayed() {
    const eventName = 'searchOverlayDisplayed';
    eventRegistry[eventName]?.(eventName, {});
  }

  onSortClick(event: CustomEvent) {
    const eventName = 'sortClick';
    const sortOption = event?.detail?.payload?.value || '';
    if (sortOption) {
      eventRegistry[eventName]?.(eventName, {
        sort_option: sortOption
      });
    }
  }

  onProductClick(event: CustomEvent) {
    const eventName = 'productClick';
    const productId = event?.detail?.productId || '';
    if (productId) {
      eventRegistry[eventName]?.(eventName, {
        product_id: [`PROD${productId}`]
      });
    }
  }

  onOverlayProductClick(event: CustomEvent) {
    const eventName = 'productClick';
    const productId = event?.detail?.productId || '';
    if (productId) {
      eventRegistry[eventName]?.(eventName, {
        product_id: [`PROD${productId}`],
        is_overlay: true
      });
    }
  }

  onQuickshopClick(event: CustomEvent) {
    const eventName = 'quickView';
    const productId = event?.detail?.productId || '';
    if (productId) {
      eventRegistry[eventName]?.(eventName, {
        product_id: [`PROD${productId}`]
      });
    }
  }

  onNavClick(event: CustomEvent) {
    const eventName = 'navigationClick';
    const promoName = event?.detail?.event?.target?.innerText || '';
    eventRegistry[eventName]?.(eventName, {
      promo_name: promoName
    });
  }

  onGlobalNavClick(event: CustomEvent) {
    this.onNavClick(event);
  }

  onSubNavClick(event: CustomEvent) {
    this.onNavClick(event);
  }

  onRegistration(event: CustomEvent) {
    const eventName = 'registration';
    const accountReferrer = event?.detail?.provider || '';
    const accountSource = event?.detail?.source || '';
    const accountType = event?.detail?.type || '';
    const userId = event?.detail?.userId || '';
    eventRegistry[eventName]?.(eventName, {
      account_referrer: accountReferrer,
      account_source: accountSource,
      account_type: accountType,
      USER_ID: userId
    });
  }

  onRegistrationFailed(event: CustomEvent) {
    const eventName = 'registrationFailed';
    const accountReferrer = event?.detail?.provider || '';
    const accountSource = event?.detail?.source || '';
    const accountType = event?.detail?.type || '';
    eventRegistry[eventName]?.(eventName, {
      account_referrer: accountReferrer,
      account_source: accountSource,
      account_type: accountType
    });
  }

  onSignIn(event: CustomEvent) {
    const eventName = 'signin';
    const accountReferrer = event?.detail?.provider || '';
    const accountRememberMe = event?.detail?.rememberMe || '';
    const accountSource = event?.detail?.source || '';
    const userId = event?.detail?.userId || '';
    eventRegistry[eventName]?.(eventName, {
      account_referrer: accountReferrer,
      account_rememberme: accountRememberMe,
      account_source: accountSource,
      USER_ID: userId
    });
  }

  onSignInFailed(event: CustomEvent) {
    const eventName = 'signinFailed';
    const accountReferrer = event?.detail?.provider || '';
    const accountSource = event?.detail?.source || '';
    eventRegistry[eventName]?.(eventName, {
      account_referrer: accountReferrer,
      account_source: accountSource
    });
  }

  onOffer(eventName: string, event: CustomEvent) {
    const offerCode = event?.detail || '';
    if (offerCode) {
      eventRegistry[eventName]?.(eventName, {
        offer_code: ['offer code' + ' - ' + offerCode]
      });
    }
  }

  onSampleAdded(event: CustomEvent) {
    const eventName = 'checkoutSampleAdded';
    const sampleProductName = event?.detail?.prodName || '';
    const sampleProductSku = event?.detail?.prodSku || '';
    if (sampleProductSku && sampleProductName) {
      eventRegistry[eventName]?.(eventName, {
        sample_product_name: sampleProductName,
        sample_product_sku: sampleProductSku
      });
    }
  }

  onSampleRemoved(event: CustomEvent) {
    const eventName = 'checkoutSampleRemoved';
    const sampleProductName = event?.detail?.prodName || '';
    const sampleProductSku = event?.detail?.prodSku || '';
    if (sampleProductSku && sampleProductName) {
      eventRegistry[eventName]?.(eventName, {
        cart_sample: [sampleProductName + ' - SKU' + sampleProductSku]
      });
    }
  }

  onRemoveFromCart(event: CustomEvent) {
    const eventName = 'removeFromCart';
    const productSku = event?.detail?.product_sku || '';
    if (productSku) {
      eventRegistry[eventName]?.(eventName, {
        product_sku: [`SKU${productSku}`],
        is_pincer_cart: true
      });
    }
  }

  onAddToCart(event: CustomEvent) {
    const eventName = 'addToCart';
    const productSku = event?.detail?.product_sku || '';
    if (productSku) {
      eventRegistry[eventName]?.(eventName, {
        product_sku: [`SKU${productSku}`],
        is_pincer_cart: true
      });
    }
  }

  onCartDrawer(event: CustomEvent) {
    const eventName = 'cartDrawer';
    const drawerItemCategory = event?.detail?.cartDrawerCategory || '';
    const drawerItemAction = event?.detail?.cartDrawerAction || '';
    const drawerItemCta = event?.detail?.cartDrawerCta || '';
    if (drawerItemCta) {
      eventRegistry[eventName]?.(eventName, {
        cartDrawerName: drawerItemCategory,
        cartDrawerCategory: drawerItemCategory,
        cartDrawerAction: drawerItemAction,
        cartDrawerCta: drawerItemCta
      });
    }
  }

  onPdpAccordion(event: CustomEvent) {
    const eventName = 'pdpAccordion';
    const productCardHeader = event?.detail?.productCardLabel || '';
    const productCardType = event?.detail?.productCardAction ? 'expand' : 'collapse';
    if (productCardHeader) {
      eventRegistry[eventName]?.(eventName, {
        eventAction: productCardType,
        eventLabel: productCardHeader
      });
    }
  }
}

// TODO: deal with this

/*
    // Event specific listeners:

    // TODO: replace with vulcan, site specific behaviors - this will return nothing currently now that we're using the new platform
    const analyticsBehavior = {};
    const events = [
      'addToCart',
      'addToFavorites',
      'checkoutOPC',
      'checkoutSampleAdded',
      'emailSignup',
      'getRecAIProdData',
      'liveChatManualInitiated',
      'liveChatManualPreSurvey',
      'liveChatManualWaiting',
      'liveChatManualChatting',
      'liveChatProactiveDisplayed',
      'liveChatProactiveInitiated',
      'liveChatProactivePreSurvey',
      'liveChatProactiveWaiting',
      'liveChatProactiveChatting',
      'offerFailed',
      'offerSuccessful',
      'profileUpdate',
      'registration',
      'removeFromCart',
      'searchPageLoaded',
      'searchPredicted',
      'searchRedirect',
      'signin',
      'signinFailed',
      'emailWishlist',
      'productThumbnailClick',
      'cancelOrder'
    ];

    for (let i = 0; i < events.length; i++) {
      // Try brand function first
      //  - otherwise try the global function
      const callback = analyticsBehavior[events[i]] || site.track[events[i]];
      site.elcEvents.addListener('track:' + events[i], (customEvent) =>
        callback(customEvent?.detail)
      );
    }

    */
